/**
 * Development-only logging utility
 * Prevents console.log statements from reaching production
 * Enable at runtime: window.SR_DEV_LOG = true
 */

/**
 * Development-only console logger
 * @param {...any} args - Arguments to log
 */
export const devLog = (...args) => {
  // FT-73: Restored production check - only log in development
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

/**
 * Development-only warning logger
 * @param {...any} args - Arguments to warn
 */
export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

/**
 * Always-on error logger (kept for production)
 * @param {...any} args - Arguments to error
 */
export const devError = (...args) => {
  // eslint-disable-next-line no-console
  console.error(...args);
};

// Export as default for convenience
export default devLog;